<template>
  <div id="conten-dashboard" class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
    <LoadingDashboardCards v-if="loading" />
    <div v-else class="space-y-8">
      <div v-if="isAccessDashboard">
        <!-- Estado de Productos Section -->
        <div class="mb-8">
          <div class="flex items-center gap-3 mb-4">
            <div class="h-8 w-1 bg-gradient-to-b from-blue-500 to-blue-600 rounded-full"></div>
            <h2 class="text-lg font-bold text-gray-800 tracking-tight">
              Estado de Productos
            </h2>
          </div>
          <ImportantReport :expiredProducts="reportsProduct.expiredProducts"
            :productsToExpired="reportsProduct.productsToExpired"
            :productsWhitMinimumStock="reportsProduct.productsWhitMinimumStock"
            :outOfStockProducts="reportsProduct.outOfStockProducts" />
        </div>

        <!-- Reporte del Día Section -->
        <div class="mb-8">
          <div class="flex items-center gap-3 mb-4">
            <div class="h-8 w-1 bg-gradient-to-b from-green-500 to-green-600 rounded-full"></div>
            <h2 class="text-lg font-bold text-gray-800 tracking-tight">
              Reporte del Día de Hoy
            </h2>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 lg:gap-4">
            <TotalSales :total="reportCurrent.sales" :date="reportCurrent.date" :money="money()" />
            <TotalShopping :total="reportCurrent.shopping" :date="reportCurrent.date" :money="money()" />
            <TotalDisbursements :total="reportCurrent.expences" :date="reportCurrent.date" :money="money()" />
            <TotalAccountsPayable :total="reportCurrent.AccountsPayable" :date="reportCurrent.date" :money="money()" />
            <TotalAccountsReceivable :total="reportCurrent.accountReceivable" :date="reportCurrent.date"
              :money="money()" />
          </div>
        </div>

        <!-- Reporte del Mes Section -->
        <div class="mb-8">
          <div class="flex items-center gap-3 mb-4">
            <div class="h-8 w-1 bg-gradient-to-b from-purple-500 to-purple-600 rounded-full"></div>
            <h2 class="text-lg font-bold text-gray-800 tracking-tight">
              Reporte del Mes Actual
            </h2>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 lg:gap-4">
            <TotalSalesForTheCurrentMonth :total="reportMonth.sales" :money="money()" />
            <TotalShoppingForTheCurrentMonth :total="reportMonth.shopping" :money="money()" />
            <TotalDisbursementsForTheCurrentMonth :total="reportMonth.expences" :money="money()" />
            <TotalAccountsPayableForTheCurrentMonth :total="reportMonth.AccountsPayable" :money="money()" />
            <TotalAccountsReceivableForTheCurrentMonth :total="reportMonth.accountReceivable" :money="money()" />
          </div>
        </div>

        <!-- Reporte General Section -->
        <div class="mb-8">
          <div class="flex items-center gap-3 mb-4">
            <div class="h-8 w-1 bg-gradient-to-b from-indigo-500 to-indigo-600 rounded-full"></div>
            <h2 class="text-lg font-bold text-gray-800 tracking-tight">
              Tablero General
            </h2>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:gap-4">
            <TotalCustomer :total="reportGeneral.customer" />
            <TotalSupplier :total="reportGeneral.supplier" />
          </div>
        </div>

        <!-- Gráficos de Ventas Diarios y Mensuales -->
        <div class="mb-8">
          <div class="flex items-center gap-3 mb-4">
            <div class="h-8 w-1 bg-gradient-to-b from-orange-500 to-orange-600 rounded-full"></div>
            <h2 class="text-lg font-bold text-gray-800 tracking-tight">
              Reportes Gráficos de Ventas
            </h2>
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
            <TotalSalesReportGrapics :datas="reportChartSales.current" />
            <TotalSalesForMonthReportGrapics :datas="reportChartSales.month" />
          </div>
        </div>

        <!-- Gráfico de Ventas Anual -->
        <div class="mb-8">
          <div class="flex items-center gap-3 mb-4">
            <div class="h-8 w-1 bg-gradient-to-b from-teal-500 to-teal-600 rounded-full"></div>
            <h2 class="text-lg font-bold text-gray-800 tracking-tight">
              Reporte de Ventas del Año Actual
            </h2>
          </div>
          <TotalSalesForYearReportGrapics :datas="reportOfTheSalesForMonth" />
        </div>

        <!-- Gráfico de Compras Anual -->
        <div class="mb-8">
          <div class="flex items-center gap-3 mb-4">
            <div class="h-8 w-1 bg-gradient-to-b from-rose-500 to-rose-600 rounded-full"></div>
            <h2 class="text-lg font-bold text-gray-800 tracking-tight">
              Reporte de Compras del Año Actual
            </h2>
          </div>
          <TotalShoppingForYearReportGrapics :datas="reportOfTheShoppingForMonth" />
        </div>
      </div>

      <!-- Welcome Screen -->
      <div v-else class="min-h-[80vh] relative">
        <div
          class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full px-4 flex items-center justify-center flex-col gap-6">
          <div class="text-center space-y-4">
            <h2 class="text-2xl md:text-3xl text-gray-700 font-medium">
              Hola
              <strong class="font-bold text-gray-900">
                {{ userName }}
              </strong>
            </h2>
            <span
              class="block text-4xl md:text-7xl font-bold bg-gradient-to-r from-gray-300 to-gray-400 bg-clip-text text-transparent">
              BIENVENIDO
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TotalAccountsPayable from "@/components/Dashboard/Cards/TodayReports/TotalAccountsPayable.vue";
import TotalAccountsReceivable from "@/components/Dashboard/Cards/TodayReports/TotalAccountsReceivable.vue";
import TotalCustomer from "@/components/Dashboard/Cards/GeneralReport/TotalCustomer.vue";
import TotalDisbursements from "@/components/Dashboard/Cards/TodayReports/TotalDisbursements.vue";
import TotalSales from "@/components/Dashboard/Cards/TodayReports/TotalSales.vue";
import TotalShopping from "@/components/Dashboard/Cards/TodayReports/TotalShopping.vue";
import TotalSupplier from "@/components/Dashboard/Cards/GeneralReport/TotalSupplier.vue";

import TotalAccountsPayableForTheCurrentMonth from "@/components/Dashboard/Cards/CurrentMonthReports/TotalAccountsPayableForTheCurrentMonth.vue";
import TotalAccountsReceivableForTheCurrentMonth from "@/components/Dashboard/Cards/CurrentMonthReports/TotalAccountsReceivableForTheCurrentMonth.vue";
import TotalDisbursementsForTheCurrentMonth from "@/components/Dashboard/Cards/CurrentMonthReports/TotalDisbursementsForTheCurrentMonth.vue";
import TotalSalesForTheCurrentMonth from "@/components/Dashboard/Cards/CurrentMonthReports/TotalSalesForTheCurrentMonth.vue";
import TotalShoppingForTheCurrentMonth from "@/components/Dashboard/Cards/CurrentMonthReports/TotalShoppingForTheCurrentMonth.vue";

//Graficos de barra
import TotalSalesReportGrapics from "@/components/Dashboard/GrapicsReport/TotalSalesReportGrapics.vue";
import TotalSalesForMonthReportGrapics from "@/components/Dashboard/GrapicsReport/TotalSalesForMonthReportGrapics.vue";
import TotalSalesForYearReportGrapics from "@/components/Dashboard/GrapicsReport/TotalSalesForYearReportGrapics.vue";
import TotalShoppingForYearReportGrapics from "@/components/Dashboard/GrapicsReport/TotalShoppingForYearReportGrapics.vue";

//Componte para mostrar datos importantes como productos por vencer, etc
import ImportantReport from "@/components/Dashboard/Important/ImportantReport.vue";
import { onMounted, ref } from "vue";
import {
  idLocalStore,
  idLocalUser,
  localUserName,
} from "@/publicjs/localStorage";
import axios from "../../api";
import { errorActions } from "@/alerts";
import { money, format } from "@/publicjs/money";

import LoadingDashboardCards from "@/components/Loadings/LoadingDashboardCards.vue";
import { observeElement } from "@/observer";
import { validateAccessSpecific } from "@/repository/Sales/ValidateAccessEspecific/ValidateAccess";

export default {
  name: "MainDashboard",
  components: {
    TotalAccountsPayable,
    TotalAccountsReceivable,
    TotalCustomer,
    TotalDisbursements,
    TotalSales,
    TotalShopping,
    TotalSupplier,
    TotalAccountsPayableForTheCurrentMonth,
    TotalAccountsReceivableForTheCurrentMonth,
    TotalDisbursementsForTheCurrentMonth,
    TotalSalesForTheCurrentMonth,
    TotalShoppingForTheCurrentMonth,
    TotalSalesReportGrapics,
    TotalSalesForMonthReportGrapics,
    TotalSalesForYearReportGrapics,
    TotalShoppingForYearReportGrapics,
    ImportantReport,
    LoadingDashboardCards,
  },
  setup() {
    const reportsProduct = ref({
      expiredProducts: 0,
      productsToExpired: 0,
      productsWhitMinimumStock: 0,
      outOfStockProducts: 0,
    });

    const reportCurrent = ref({
      sales: 0,
      shopping: 0,
      accountReceivable: 0,
      AccountsPayable: 0,
      expences: 0,
      date: "",
    });
    const reportMonth = ref({
      sales: 0,
      shopping: 0,
      accountReceivable: 0,
      AccountsPayable: 0,
      expences: 0,
      start: "",
      end: "",
    });
    const reportGeneral = ref({
      customer: 0,
      supplier: 0,
    });
    const reportChartSales = ref({
      current: null,
      month: null,
    });
    const reportOfTheSalesForMonth = ref({});
    const reportOfTheShoppingForMonth = ref({});
    const idStore = ref(0);
    const isAccessDashboard = ref(false);
    const userName = ref("");

    const loading = ref(true);

    const getSalesAndShoppingAndProductsCurrent = async () => {
      const response = await axios
        .get(`ventas-compras-cp-cc-del-dia/${idStore.value}`)
        .catch((error) => errorActions(error));
      const data = await response.data;
      //Productos
      reportsProduct.value.expiredProducts = parseInt(data.productos_vencidos);
      reportsProduct.value.productsToExpired = parseInt(
        data.productos_por_vencer
      );
      reportsProduct.value.productsWhitMinimumStock = parseInt(
        data.productos_con_stock_minimo
      );
      reportsProduct.value.outOfStockProducts = parseInt(
        data.productos_agotados
      );

      //ventas

      reportCurrent.value.sales = format(data.ventas);
      reportCurrent.value.shopping = format(data.compras);
      reportCurrent.value.accountReceivable = format(data.cuentas_por_cobrar);
      reportCurrent.value.AccountsPayable = format(data.cuentas_por_pagar);
      reportCurrent.value.expences = format(data.desembolsos);
      reportCurrent.value.date = data.fecha;
    };

    const getSalesAndShoppingAndProductsMonth = async () => {
      const response = await axios
        .get(`ventas-compras-cp-cc-del-mes/${idStore.value}`)
        .catch((error) => errorActions(error));
      const data = await response.data;

      //ventas

      reportMonth.value.sales = format(data.ventas);
      reportMonth.value.shopping = format(data.compras);
      reportMonth.value.accountReceivable = format(data.cuentas_por_cobrar);
      reportMonth.value.AccountsPayable = format(data.cuentas_por_pagar);
      reportMonth.value.expences = format(data.desembolsos);
      reportMonth.value.start = data.fecha_de_inicio;
      reportMonth.value.end = data.fecha_de_termino;
    };
    const getReportGeneral = async () => {
      const response = await axios
        .get(`reporte-general-dashboard`)
        .catch((error) => errorActions(error));
      const data = await response.data;

      reportGeneral.value.customer = format(data.clientes);
      reportGeneral.value.supplier = format(data.proveedores);
    };

    const getSalesAndShoppingOfTheMonth = async () => {
      const response = await axios
        .get(`ventas-del-dia-chart/${idStore.value}`)
        .catch((error) => errorActions(error));
      const data = await response.data;

      reportChartSales.value.month = data.ventas_del_mes;
      reportChartSales.value.current = data.ventas_del_dia;
    };
    const getSalesAndShoppingOfTheYear = async () => {
      const response = await axios
        .get(`ventas-y-compras-por-mes-chart/${idStore.value}`)
        .catch((error) => errorActions(error));
      const data = await response.data;
      reportOfTheSalesForMonth.value = data.ventas;
      reportOfTheShoppingForMonth.value = data.compras;
    };

    onMounted(async () => {
      observeElement("#conten-dashboard");
      idStore.value = await idLocalStore();
      userName.value = await localUserName();

      const ACCESS = ["DASHBOARD"];

      const validate = await validateAccessSpecific(
        ACCESS,
        await idLocalUser()
      );

      if (validate.includes("DASHBOARD")) {
        isAccessDashboard.value = true;
      }
      if (isAccessDashboard.value) {
        // Optimización: Ejecutar todas las llamadas API en paralelo en lugar de secuencialmente
        await Promise.all([
          getSalesAndShoppingAndProductsCurrent(),
          getSalesAndShoppingAndProductsMonth(),
          getReportGeneral(),
          getSalesAndShoppingOfTheMonth(),
          getSalesAndShoppingOfTheYear()
        ]);
      }
      loading.value = false;
    });

    return {
      reportsProduct,
      loading,
      reportCurrent,
      money,
      reportMonth,
      reportGeneral,
      reportChartSales,
      reportOfTheSalesForMonth,
      reportOfTheShoppingForMonth,
      isAccessDashboard,
      userName,
    };
  },
};
</script>
